module.exports = __webpack_public_path__ + "img/consultoria_3-4_768.69f2dbae.webp";